import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useFilterPhieuNhapXuat } from '@/core/hooks/useFilterPhieuNhapXuat';
import { PhieuNhapXuatStatusEnum } from '@/core/enums/phieuNhapXuatStatus.enum';
import { mapPhieuNhapXuatStatusToLabel } from '@/core/helpers/utils';
import FilterItem from '@/layout/_shared/FilterItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterPhieuNhapXuat',
  props: {
  loaiPhieu: {
    type: String as () => 'nhap' | 'xuat',
    required: true
  }
},
  emits: ["update-filters"],
  setup(__props, { emit: __emit }) {

const props = __props;

const {
  processStatusFilter,
  loaiPhieuFilter,
} = useFilterPhieuNhapXuat({
  loaiPhieu: props.loaiPhieu,
});

const emits = __emit;

watch([processStatusFilter, loaiPhieuFilter], () => {
  emits('update-filters', {
    loaiPhieuFilter: loaiPhieuFilter.value,
    processStatusFilter: processStatusFilter.value,
  });
});

const phieuProcessingStatuses = [
  PhieuNhapXuatStatusEnum.PENDING,
  PhieuNhapXuatStatusEnum.FAILED,
  PhieuNhapXuatStatusEnum.PROCESSING,
  PhieuNhapXuatStatusEnum.SUCCESS,
];

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FilterItem, { label: "Loại phiếu" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_select, {
          modelValue: _unref(loaiPhieuFilter),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loaiPhieuFilter) ? (loaiPhieuFilter).value = $event : null)),
          clearable: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: `Tất cả`,
              value: ''
            }),
            _createVNode(_component_el_option, {
              label: props.loaiPhieu === 'nhap' ? 'Nhập khác' : 'Xuất khác',
              value: 0
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              label: `Theo ${props.loaiPhieu === 'nhap' ? 'hợp đồng' : 'biên bản'}`,
              value: 1
            }, null, 8, ["label"]),
            (__props.loaiPhieu === 'xuat')
              ? (_openBlock(), _createBlock(_component_el_option, {
                  key: 0,
                  label: "Xuất v/tư thu hồi",
                  value: 2
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(FilterItem, { label: "Trạng thái xử lý:" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_select, {
          modelValue: _unref(processStatusFilter),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(processStatusFilter) ? (processStatusFilter).value = $event : null))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "Tất cả",
              value: ''
            }),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(phieuProcessingStatuses, (status) => {
              return _createVNode(_component_el_option, {
                key: status,
                label: _unref(mapPhieuNhapXuatStatusToLabel)(status),
                value: status
              }, null, 8, ["label", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ], 64))
}
}

})